const BlueprintEditorRightPanelFetchCustomFieldMappingForm = () => {
  return <div></div>;
};

export default BlueprintEditorRightPanelFetchCustomFieldMappingForm;
